<template>
  <v-dialog v-model="dialog" content-class="max-height overflow-hidden" width="1000">
    <v-card class="d-flex max-height flex-column">
      <DialogHeader style="flex: 0 0!important;" @close="close()" title="Import logs" />
      <v-card-text class="overflow-auto pb-4" style="flex: 1 0;">
        <PageLoader class="mt-5 pt-5" v-if="loading" resource-name="import logs" />
        <ServiceUserLogs ref="serviceUserLogs" :executionId="executionId" :isRollback="isRollback" :loading.sync="loading" />
      </v-card-text>
      <v-divider style="flex: 0 0;" />
      <v-card-actions style="flex: 0 0 !important;">
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close()">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import ServiceUserLogs from '@/components/ServiceRegistry/Logs/ServiceUserLogs'

  export default {
    components: {
      ServiceUserLogs,
    },
    data: () => ({
      dialog: false,
      loading: false,
      executionId: null,
      isRollback: false,
    }),
    methods: {
      async show(executionId, isRollback) {
        this.dialog = true
        this.executionId = executionId
        this.isRollback = isRollback
        await this.$nextTick()
        await this.$refs.serviceUserLogs.fetchLogs()
      },
      close() {
        this.dialog = false
        this.executionId = null
        this.isRollback = null
      },
    },
  }
</script>